import React from "react";
import { CheckBoxPresenter, PresenterProps } from "./CheckBox";

type CheckBoxProps = PresenterProps;

export const CheckBox: React.FC<CheckBoxProps> = (props) => {
  return <CheckBoxPresenter {...props}></CheckBoxPresenter>;
};
